// extracted by mini-css-extract-plugin
module.exports = {"icon":"InputTextIcon_icon__1YpOe","inputGroup":"InputTextIcon_inputGroup__1nry5","inputIcon":"InputTextIcon_inputIcon__16HJL"};